import React from 'react';

const CopilotWebChat = () => {
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe 
        src="https://copilotstudio.microsoft.com/environments/Default-64e9d13a-815e-45db-9b04-d988afc6bdf3/bots/cr4e4_copilot/webchat?__version__=2" 
        frameBorder="0" 
        style={{ width: '100%', height: '100%' }} 
        title="Copilot WebChat"
      />
    </div>
  );
};

export default CopilotWebChat;
